<template>
    <ion-button
        class="button-toggle"
        :class="{active: model === true}"
        expand="block"
        @click="props.externalEventHandling ? void 0 : model = !model"
    >
        <slot />
    </ion-button>
</template>

<script setup lang="ts">
import {IonButton} from '@ionic/vue';

const model = defineModel()
const props = defineProps<{
    externalEventHandling?: boolean
}>()
</script>

<style lang="scss">
.button-toggle {
    --background: var(--ion-color-light);
    --background-hover: var(--ion-color-light);
    --background-activated: var(--ion-color-light);
    --background-focused: var(--ion-color-light);
    --color: var(--color-black);

    &.active {
        --background: var(--ion-color-primary-tint-3);
        --background-hover: var(--ion-color-primary-tint-3);
        --background-activated: var(--ion-color-primary-tint-3);
        --background-focused: var(--ion-color-primary-tint-3);
        --color: var(--ion-color-primary);
    }
}
</style>
